import { observer } from 'mobx-react-lite'
import { EmptyState, Table } from 'shared/ui'
import { useWorkflowListContext } from 'pages/workflows/context/workflowListContext'
import { useWorkflowTable } from './useWorkflowTable'
import styles from './styles.module.scss'

export const WorkflowTable = observer(() => {
  const { page, limit, total, loading, changePaging } = useWorkflowListContext()
  const { rows, columns, columnsIds, setColumnIds } = useWorkflowTable()

  if (!loading && !rows.length) return <EmptyState text='No workflows found' />

  return (
    <div className={styles.table}>
      <Table
        ariaLabel={'WorkflowTable'}
        columns={columns}
        rows={rows}
        pinnedColumnNames={['name']}
        initPage={page}
        limit={limit}
        isLoading={loading}
        visibleColumnsIds={columnsIds}
        setVisibleColumnsIds={setColumnIds}
        rowsCount={total}
        onChangePagination={changePaging}
        startPaginationSize={10}
      />
    </div>
  )
})
